<template>
  <div style="margin-top: 0;">
    <b-card :title="(newModel.id ? dataConfig.titleSingular + ' bearbeiten' : dataConfig.titleSingular + ' hinzufügen')">
      <form @submit.prevent="saveFormData">
        <b-form-group :class="formClass" v-for="head in inputTabs" :key="head.db_key">
          <label style="text-transform: none;" v-if="shownCategories && shownCategories.includes(head.category)">
            {{ head.category }}:
          </label>
          <label style="text-transform: none;"> {{ head.label }} </label>
          <div v-if="['String', 'Number'].includes(head.input_type)">
            <b-form-input type="text" v-model="newModel[head.db_key]"></b-form-input>
          </div>
          <div v-else-if="head.input_type === 'Array'">
            <multiselect placeholder="Bitte auswählen" v-model="newModel[head.db_key]" :options="categories[head.db_key]" :multiple="true" />
          </div>
          <div v-else-if="head.input_type === 'Textarea'">
            <b-form-textarea v-model="newModel[head.db_key]"></b-form-textarea>
          </div>
          <div v-else-if="head.input_type === 'Boolean'">
            <input type="checkbox" v-model="newModel[head.db_key]"> {{ (newModel[head.db_key]) ? 'Ja' : 'Nein' }}
          </div>
          <div v-else-if="head.input_type === 'Date'">
            <datepicker placeholder="Bitte auswählen" v-model="newModel[head.db_key]" :language="de" :bootstrap-styling="true"></datepicker>
          </div>
          <div v-else-if="head.input_type === 'Time'">
            <vue-timepicker placeholder="Bitte auswählen" v-model="newModel[head.db_key]"></vue-timepicker>
          </div>
        </b-form-group>
        <b-form-group v-if="newModel.photo_path" :class="formClass">
          <label> Gespeicherte Bilder </label>
          <div>
            <multiselect placeholder="Keine Bilder ausgewählt" :options="imageNames" v-model="chosenImages" :multiple="true" />
          </div>
        </b-form-group>
        <div v-if="!containsImages" class="fields">
          <b-btn type="submit" variant="success">{{ dataConfig.titleSingular }} speichern</b-btn>
        </div>
      </form>
      <form v-if="containsImages" @submit.prevent="saveFormData" @change="computeCurrentUploadSize" enctype="multipart/form-data">
        <label> Bilddateien hinzufügen (max. 12 MB) </label>
        <input type="file" ref="woundImage" multiple />
        <div class="fields" style="display: flex;">
          <b-btn :disabled="uploadTooLarge" type="submit" variant="success">{{ dataConfig.titleSingular }} speichern</b-btn>
          <information v-if="uploadTooLarge" :infoText="'Ihre Bilddateien überschreiten die erlaubten 12 MB.'" :extraStyles="'margin-top: -90px;'" />
        </div>
      </form>
    </b-card>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import helpers from '@/mixins/helper-functions'
import api from '@/api'
import Datepicker from 'vuejs-datepicker'
import { de } from 'vuejs-datepicker/dist/locale' // For German Language in Calendar
import VueTimepicker from 'vue2-timepicker'
import 'vue2-timepicker/dist/VueTimepicker.css'
import ExperimentForm from './ExperimentForm'
import Information from './Information'

export default {
  name: 'akribes-form',
  components: {
    Multiselect,
    Datepicker,
    VueTimepicker,
    'experiment-form': ExperimentForm,
    'information': Information
  },
  props: {
    dataConfig: Object,
    containsImages: Boolean,
    routeID: String
  },
  data () {
    return {
      newModel: {
        'unit': helpers.compoundToUnit[this.$route.params.experiment]
      },
      de: de,
      categories: {
        gender: [],
        medication: [],
        comorbidity: [],
        woundkind: [],
        woundcolor: [],
        woundsurrounding: [],
        woundedgequality: [],
        woundedgecondition: [],
        woundgroundtissue: [],
        woundgroundcolor: [],
        exudatquality: [],
        exudatamount: [],
        samplekind: []
      },
      categoryNames: this.dataConfig.tableHeader.filter(head => head.input_type === 'Array').map(head => head.db_key),
      chosenImages: [],
      currentUploadSize: 0,
      shownCategories: this.dataConfig.shownCategories
    }
  },
  async created () {
    if (this.postResource === 'patient') {
      await this.loadCategories()
    }
  },
  computed: {
    formClass () { // Patient and Experiment Route have different style than the rest
      if (['patient', 'experiment'].includes(this.$route.name)) {
        return 'col-md-3'
      }
    },
    inputTabs () {
      return this.dataConfig.tableHeader.filter(row => !['Image', 'Computed', 'ComputedDate', 'ComputedNumber', 'Assocs'].includes(row.input_type))
    },
    dbToModel () {
      var transDict = {}
      this.categoryNames.forEach(name => {
        transDict[helpers.getAssociationName(name)] = name
      })
      return transDict
    },
    postResource () {
      return helpers.getPostResource(this.$route)
    },
    availableImages () {
      if (this.newModel.photo_path) {
        return this.newModel.photo_path.split(',')
      }
    },
    imageNames () {
      if (this.availableImages) {
        var images = this.availableImages.map((im, ind) => `Bild ${ind + 1}`)
        this.chosenImages = images
        return images
      }
    },
    uploadTooLarge () {
      return this.currentUploadSize > 12000000
    }
  },
  methods: {
    computeCurrentUploadSize () {
      if (this.$refs.woundImage) {
        var woundImage = this.$refs.woundImage.files
        this.currentUploadSize = Object.values(woundImage).map(im => im.size).reduce((acc, cur) => acc + cur)
      }
    },
    async saveFormData () {
      var formData = new FormData()

      if (this.containsImages) { // Handling uploaded image
        var woundImage = this.$refs.woundImage.files
        Object.values(woundImage).forEach(image => {
          formData.append('woundImage', image)
        })
        const imageFileName = this.newModel.day_id.replaceAll(/[,<>:"/\\|?*]/g, '') // escape illegal chars
        var uploadImageResponse = await api.uploadImage(imageFileName, formData) // get paths of newly uploaded images
        var editedImageIndices = this.chosenImages.map(im => parseInt(im.slice(-1)) - 1)
        var editedImages = editedImageIndices.map(ind => this.availableImages[ind]) // get paths of edited images
        this.newModel.photo_path = editedImages.concat(uploadImageResponse.map(image => image.path)).join(', ')
        if (this.newModel.photo_path.length === 0) this.newModel.photo_path = null
        var photoTime = this.newModel.photo_time
        if (photoTime && typeof photoTime === 'object') {
          this.newModel.photo_time = photoTime.HH + ':' + photoTime.mm
        }
      }

      if (!this.$route.path.includes('compound')) {
        delete this.newModel.unit
      }

      var newModel = this.newModel
      Object.keys(newModel).forEach(key => {
        if (typeof newModel[key] === 'string' && !isNaN(newModel[key].replace(',', '.'))) newModel[key] = newModel[key].replace(',', '.')
      })

      var response
      if (this.routeID) {
        response = await api.updatePost(this.postResource, this.newModel.id, this.newModel)
      } else {
        response = await api.createPost(this.postResource, this.newModel)
      }
      helpers.createUploadFeedback(response)
      this.newModel = {}

      if (this.$route.params.id) {
        var nextPath = (this.$route.name === 'properties') ? `/patient-properties/${this.postResource}` : `/${this.postResource}`
        this.$router.push(nextPath)
      }
      this.$router.go()
    },
    async loadCategories () {
      // Get all Table Headers with categorical input
      var categoryLists = await api.getCategoryLists(this.categoryNames)
      this.categories = categoryLists
    },
    async getModelByID (id) {
      if (id) {
        var newModel = {}
        var model = await api.getPost(this.postResource, id)
        newModel = model
        const arrayKeys = Object.keys(model).filter(key => Array.isArray(model[key])) // get all keys with Array values
        arrayKeys.forEach(key => {
          newModel[this.dbToModel[key]] = model[key].map(obj => obj.option)
          delete newModel[key]
        })
        this.newModel = newModel
      } else {
        this.newModel = {}
      }
    },
    async getPropertyByID (id) {
      if (id) {
        var dbID = this.$route.params.db_id
        var newModel = {}
        var model = await api.getPost(dbID, id)
        newModel.id = model.id
        newModel.option = model.option
        if (dbID === 'medication') {
          // Medication is associated to effects and substances, while substances again are associated to moas
          model.substances.forEach((substance, ind1) => {
            newModel[`wirkstoff_${ind1 + 1}`] = substance.substance
            substance.moas.forEach((moa, ind2) => {
              newModel[`moa_${ind1 + 1}_${ind2 + 1}`] = moa.moa
            })
          })
          model.effects.forEach((effect, ind) => {
            newModel[`therapeutischer_effekt_${ind + 1}`] = effect.effect
          })
        }
        this.newModel = newModel
      } else {
        this.newModel = {}
      }
    }
  },
  watch: {
    async routeID (id) {
      if (this.$route.name === 'properties') {
        await this.getPropertyByID(id)
      } else {
        await this.getModelByID(id)
      }
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css" />



// WEBPACK FOOTER //
// src/components/plugins/AkribesForm.vue